import { getOrCreateVisitorCorrelationId } from '../../../utils/correlation-id'
import { PortableAPI } from './portable-api'

export class LoyaltyPointsAPI extends PortableAPI {
	protected async requestParameters(): Promise<RequestInit> {
		const tokens = await window.gbpe.auth.getValidTokens?.()
		const idToken = tokens?.idToken || window.gbpe.auth.idToken || ''
		const headers: HeadersInit = new Headers({
			uAuthorization: idToken,
			locale: window.gbpe.config.locale,
			'x-correlation-id': getOrCreateVisitorCorrelationId(),
		})
		return {
			method: 'GET',
			headers,
		}
	}
}
